import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogRef } from '@angular/material/dialog';
import { EnableEscCloseDirective } from '../../shared/directives/enable-esc-close.directive';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { DomSanitizer } from '@angular/platform-browser';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { UserSettingsActions } from '@states/user-settings/user-settings.action-types';
import { UserSettingsEffect } from '@effects/user-settings.effect';
import { ofType } from '@ngrx/effects';
import { tap } from 'rxjs';
import { UiButtonComponent } from '@ui';

export enum FeedbackType {
  REMIND_LATER,
  DONT_ASK_AGAIN,
  NOT_NOW,
}

@Component({
  selector: 'g2-feedback-modal',
  templateUrl: './g2-feedback-modal.component.html',
  styleUrls: ['./g2-feedback-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  hostDirectives: [EnableEscCloseDirective],
  imports: [TranslatePipe, MatDialogClose, UiButtonComponent, ReactiveFormsModule],
})
export class G2FeedbackModalComponent implements OnInit {
  public isReviewStarted = false;
  public isCustomReviewStarted = false;
  public hoverRating = 0;
  public selectedRating = 0;
  public feedbackMessageControl = new FormControl('', Validators.required);

  constructor(
    private dialogRef: MatDialogRef<G2FeedbackModalComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { url: string },
    public sanitizer: DomSanitizer,
    public store$: Store,
    private userSettingsEffects: UserSettingsEffect,
  ) {}

  ngOnInit() {
    this.userSettingsEffects.createG2Feedback$
      .pipe(
        ofType(UserSettingsActions.createG2FeedbackSuccess),
        tap(() => {
          this.dialogRef.close();
        }),
      )
      .subscribe();
  }

  public remindLater() {
    this.dialogRef.close(FeedbackType.REMIND_LATER);
  }

  public dontAskAgain() {
    this.dialogRef.close(FeedbackType.DONT_ASK_AGAIN);
  }

  public start() {
    if (this.selectedRating === 5) {
      this.isReviewStarted = true;

      this.dialogRef.updateSize('900px', '700px');
    } else {
      this.isCustomReviewStarted = true;
    }
  }

  public closeCustomReview() {
    this.isCustomReviewStarted = false;
  }

  public createFeedback() {
    this.store$.dispatch(
      UserSettingsActions.createG2Feedback({
        message: this.feedbackMessageControl.value,
        rating: this.selectedRating,
      }),
    );
  }
}
